import { Button } from '@components/ui/button';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

const TakeMeHomeBtn = () => {
  const t = useTranslations('common');
  return (
    <Link href="/">
      <Button className="w-full md:w-auto">{t('take-me-home')}</Button>
    </Link>
  );
};

export default TakeMeHomeBtn;
